<div class='input-pop-navigation'>
  <div class='w-275 custom-title'>
    <pt-icon (click)='goBack()'
             *ngIf='path.length > 0'
             [key]='IconBack'
             class='me-2 cursor-pointer'
             container='body'
             ngbTooltip="{{'BUTTON.BACK' | translate}}"
             placement='right'
             tooltipClass='custom-tooltip'>
    </pt-icon>
    <span class='text-truncate'>
        {{ getTitle() }}
      </span>
    <pt-icon (click)='closePanel()'
             [key]='IconClose'
             class='close-icon close'
             container='left'
             ngbTooltip="{{'BUTTON.CLOSE' | translate}}"
             placement='bottom'
             tooltipClass='custom-tooltip'>
    </pt-icon>
  </div>

  <div *ngIf='enabledSearch' class='mb-1'>
    <input (ngModelChange)='changeFilter($event)'
           [(ngModel)]='filterValue'
           [id]='resourceNavigationId'
           class='form-control resource-navitation-filter'
           placeholder='Filter...'
           type='text'>
  </div>

  <div #navigationList class='w-275 h-265 navigation-body'>
    <ul class='list-link' *ngIf="currentList">
      <ng-container *ngFor='let children of currentList'>
        <li (click)='selectItem(children)' [ngClass]="{'auth-folder' : children.auth,
            'disabled-folder': !children.auth, 'selected-folder': children.id === selectedResourceId}"
            class='list-item' id="fold_{{children.id}}">
          <pt-icon [iconType]="'SVG'" [key]='children.image' [size]='20'></pt-icon>
          <span class='text-truncate'>{{ children.name }}</span>
          <pt-icon (click)='$event.stopPropagation(); expandChildren(children)' *ngIf='haveChildren(children)' [key]='IconNext' [size]='20'
                   class='next'
          ></pt-icon>
        </li>
      </ng-container>
    </ul>
  </div>
</div>
